// extracted by mini-css-extract-plugin
module.exports = {"background":"Toggle_background__vngOI","toggle":"Toggle_toggle__2lnmU","transform":"Toggle_transform__EG1T8","gradient":"Toggle_gradient__30CU5"};